import { FiPlus, FiTrash } from "react-icons/fi";
import Buttons from "../../../../components/button";
import { LabeledCheckbox } from "../../../../components/checkbox";
import { JobAppWorkHistoryResponse } from "../../../api-docs";
import { MultiFieldSet } from "@/components/utils/useFieldSet";
import { WorkHistoryFields } from "modules/self-apply/validation/candidate-self-apply";
import { ValidationMessage } from "@/flokit/core/validation-message/validation-message";
import { TextInput } from "@/flokit/compound/inputs/text-input/text-input";

const initialValue = (): WorkHistoryFields => ({
  employer: "",
  position: "",
  startDate: "",
  endDate: "",
  isCurrentEmployer: false,
});

export const WorkHistoryFragment = (
  props: MultiFieldSet<WorkHistoryFields> & {
    employerRequired?: boolean;
    positionRequired?: boolean;
    startDateRequired?: boolean;
    endDateRequired?: boolean;
    isRequired?: boolean;
    jobAppId?: number;
    onChange: (
      index: number,
      value: unknown,
      field: keyof JobAppWorkHistoryResponse,
    ) => void;
  },
) => {
  const info = props;
  return (
    <>
      <div className="divide-dublin-gray flex flex-col divide-y">
        {info?.values?.map((item, index) => (
          <div key={index} className="py-5 first:py-0 first:pb-5">
            <div className="relative grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-2">
              <div className="col-span-2">
                <TextInput
                  name="company"
                  isRequired={info.employerRequired}
                  label="Employer"
                  onBlur={info.onBlur("employer")}
                  shouldShowValidation={info.validation?.[index]?.employer}
                  validationMessage={info.validationMsg?.[index]?.employer}
                  onChange={(v) => info.onChange(index, v, "employer")}
                  value={item.employer}
                />
              </div>
              <div className="col-span-2">
                <TextInput
                  name="title"
                  isRequired={info.positionRequired}
                  onBlur={info.onBlur("position")}
                  shouldShowValidation={info.validation?.[index]?.position}
                  validationMessage={info.validationMsg?.[index]?.position}
                  label="Position Title"
                  onChange={(v) => info.onChange(index, v, "position")}
                  value={item.position}
                />
              </div>
              {/* This is correct, for some reason jsx-a11y isn't picking up the checkbox as a valid input component */}
              <LabeledCheckbox
                onChange={(v) => info.onChange(index, v, "isCurrentEmployer")}
                label="Current Employer"
                value={item.isCurrentEmployer}
              />

              <div className="col-span-2 flex w-full flex-col gap-y-3 md:flex md:flex-row md:gap-x-3">
                <TextInput
                  isRequired={info.startDateRequired}
                  type="date"
                  name="startDate"
                  label="Start Date"
                  onChange={(value) => {
                    info.onChange(index, value, "startDate");
                  }}
                  validationMessage={info.validationMsg?.[index]?.startDate}
                  shouldShowValidation={info.validation?.[index]?.startDate}
                  value={item.startDate}
                />
                {!item.isCurrentEmployer ? (
                  <TextInput
                    isRequired={info.endDateRequired}
                    type="date"
                    name="endDate"
                    label="End Date"
                    onChange={(value) => {
                      info.onChange(index, value, "endDate");
                    }}
                    value={item.endDate}
                    shouldShowValidation={info.validation?.[index]?.endDate}
                    validationMessage={info.validationMsg?.[index]?.endDate}
                  />
                ) : null}
              </div>
            </div>
            <div className="mt-5 flex justify-end">
              <Buttons.Micro
                className="hover:text-destructive flex gap-x-2"
                variant="ghost"
                onClick={() => info.removeItem(index)}
              >
                <FiTrash size={14} />
                <span>Remove Entry</span>
              </Buttons.Micro>
            </div>
          </div>
        ))}
      </div>
      <div>
        <Buttons.Micro
          onClick={() => info.addItem(initialValue())}
          className="flex gap-x-2"
          variant="secondary"
        >
          <FiPlus />
          <span>Add Experience</span>
        </Buttons.Micro>
      </div>
      {props.isRequired && !info.hasAllValid && info.hasAnyDirty ? (
        <div className="pt-4">
          <ValidationMessage
            shouldShowValidation
            validationMessage="Please add at least one work history entry"
          />
        </div>
      ) : null}
    </>
  );
};
